import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import MovieIcon from '@mui/icons-material/Movie';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

function EmptyWatchlists() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [firstWatchlistOpen, setFirstWatchlistOpen] = React.useState(false);
  const [watchlistName, setWatchlistName] = React.useState(null);

  const handleFirstWatchlistClose = () => {
    setFirstWatchlistOpen(false);
  };

  function handleWatchlistNameChange(event) {
    setWatchlistName(event.target.value);
  }

  function createWatchlistRemote() {
    if (watchlistName === null) {
      return null;
    }

    const url = '/watchlists' + '?name=' + watchlistName;
    const msg = fetch(url, { method: 'POST' })
      .then(resp => resp.json)

    handleFirstWatchlistClose();
    window.location.href = '/profile';
  }

  const handleClickFirstWatchlistOpen = () => {
    setFirstWatchlistOpen(true);
  };

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
        <p><strong>Watchlists</strong></p>
        <div >
          <Button size="small" variant="outlined" onClick={handleClickFirstWatchlistOpen} startIcon={<MovieIcon />}>Create a watchlist</Button>
          <Dialog fullScreen={fullScreen} onClose={handleFirstWatchlistClose} open={firstWatchlistOpen}>
            <DialogTitle>Create your first watchlist</DialogTitle>
            <DialogContent>
              <TextField
                required
                autoFocus
                margin="dense"
                id="watchlistName"
                label="Fill in a name for your Watchlist"
                fullWidth
                variant="standard"
                value={watchlistName}
                onChange={handleWatchlistNameChange}
              />
            </DialogContent>
            <DialogActions>
              <Button size="small" onClick={handleFirstWatchlistClose}>Cancel</Button>
              <Button size="small" onClick={createWatchlistRemote}>Submit</Button>
            </DialogActions>
          </Dialog>
        </div>
      </p>
    </div>
  );
}

export default EmptyWatchlists;
